import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
const toastr = require("toastr");
import "jquery-mask-plugin";
const Mustache = require("mustache");

const Utils =  function($) {
  $(document).on("ready page:load turbolinks:load", function() {
    $.fn.select2.defaults.set("theme", "bootstrap4");
    $.fn.select2.defaults.set("language", "pt-BR");

    $('.currency').mask('000.000.000.000.000,00', {reverse: true})
    $('.phone').mask('(00) 0000-00009')
    $('.cpf').mask('000.000.000-00', {reverse: true})
    $('.cnpj').mask('00.000.000/0000-00', {reverse: true})

    let options = {
      onKeyPress: (value, e, field, options) => {
        let masks = ['000.000.000-00999', '00.000.000/0000-00'];
        let mask = masks[(value.length > 14 ? 1 : 0)];
        $('.cpf_cnpj').mask(mask, options);
	  }
    };
    $('.cpf_cnpj').mask('000.000.000-00999', options);
	$('.cpf_cnpj').blur( () => {
		  if (window.validaCpfCnpj($('.cpf_cnpj').val()) == false) {
			toastr.error('CPF/CNPJ inválido!', 'Erro!')
	  		$('.cpf_cnpj').focus();
			return false;
		 }
	  });


	$("#mail_body_sucess .trix-button-group-spacer").each(function(){
		this.innerHTML = "Nome = #NAME# | Usuáiro = #USER# | Senha = #PASSWORD#" ;
	});

	$("#mail_body_waiting_payment .trix-button-group-spacer").each(function(){
		this.innerHTML = "Nome = #NAME# | Link Boleto/PIX = #CHECKOUT_URL#" ;
	});

  $("select.select2").each(function(){
      var select2_field = $(this);
      if (select2_field.data('url')){
        // select2_field.select2({theme: "bootstrap4",language: "pt-BR"})
        window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
      } else {
        if (select2_field[0] && select2_field[0].name.indexOf("country_code")) {
          var fnFormat = (country) => {
            if (country.selected) {
              if (country.id == "BR")
                $('.phone').mask('(00) 0000-00009')
              else
                $('.phone').unmask()
            }

            console.log(country);
            if (country.id)
              return  $('<div><span class="' + country.element.dataset.icon + '"></span>' + country.text + '</div>');
            return country.text;
          };
          select2_field.select2({
            templateResult: fnFormat,
            templateSelection: fnFormat
          })
        } else
          select2_field.select2()
      }
  })

    let cepOptions =  {
      onComplete: (cep, event, currentField) =>{

        let card = currentField.parents('.card')

        if (cep.length > 6){
          window.cep(cep).then( (value) => {
            card.find("[name$='[city]']").val(value.city)
            card.find("[name$='[address]']").val(value.street)
            card.find("[name$='[district]']").val(value.neighborhood)
            card.find("[name$='[state]']").val(value.state)
          }).catch(
            console.log('CEP não encontrado ou serviço indisponível.')
            // toastr.error('CEP não encontrado ou serviço indisponível.', 'Erro!')
          )
        }


      }
    }

    $('input.cep').unmask().mask('00000-000',cepOptions)

    flatpickr("input.date_picker", {dateFormat: 'd/m/Y', "locale": Portuguese })
    flatpickr("input.time_picker", {"locale": Portuguese, time_24hr: true, enableTime: true, noCalendar: true})

    let now = new Date
    flatpickr("input.month_picker", {"locale": Portuguese,
      minDate: now.getFullYear()+'-'+(now.getMonth()+1),
      plugins: [
        new monthSelectPlugin({
          shorthand: true, //defaults to false
          dateFormat: "m/Y", //defaults to "F Y"
          altFormat: "m/Y", //defaults to "F Y"
          theme: "light" // defaults to "light"
        })
      ]
    })


    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-bottom-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "500",
      "hideDuration": "1000",
      "timeOut": "10000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    const showToastType = {
      notice: 'success',
      success: 'success',
      alert: 'error',
      error: 'error',
      warning: 'warning',
      info: 'info'
    };

    const showToastOptions = {
      notice: {},
      alert: { "timeOut": "0", "extendedTimeOut": "0" },
      warning: { "timeOut": "0", "extendedTimeOut": "0" },
      info: {}
    };

	window.validaCpfCnpj = function(val) {
      if (val.length == 14) {
          var cpf = val.trim();

          cpf = cpf.replace(/\./g, '');
          cpf = cpf.replace('-', '');
          cpf = cpf.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cpf.length > i; i++) {
              if (cpf[i - 1] != cpf[i]) {
                  aux = true;
              }
          }

          if (aux == false) {
              return false;
          }

          for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
              v1 += cpf[i] * p;
          }

          v1 = ((v1 * 10) % 11);

          if (v1 == 10) {
              v1 = 0;
          }

          if (v1 != cpf[9]) {
              return false;
          }

          for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
              v2 += cpf[i] * p;
          }

          v2 = ((v2 * 10) % 11);

          if (v2 == 10) {
              v2 = 0;
          }

          return (v2 == cpf[10]);
      } else if (val.length == 18) {
          var cnpj = val.trim();

          cnpj = cnpj.replace(/\./g, '');
          cnpj = cnpj.replace('-', '');
          cnpj = cnpj.replace('/', '');
          cnpj = cnpj.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cnpj.length > i; i++) {
              if (cnpj[i - 1] != cnpj[i]) {
                  aux = true;
              }
          }

          if (aux == false) {
              return false;
          }

          for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
              if (p1 >= 2) {
                  v1 += cnpj[i] * p1;
              } else {
                  v1 += cnpj[i] * p2;
              }
          }

          v1 = (v1 % 11);

          if (v1 < 2) {
              v1 = 0;
          } else {
              v1 = (11 - v1);
          }

          if (v1 != cnpj[12]) {
              return false;
          }

          for (var i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
              if (p1 >= 2) {
                  v2 += cnpj[i] * p1;
              } else {
                  v2 += cnpj[i] * p2;
              }
          }

          v2 = (v2 % 11);

          if (v2 < 2) {
              v2 = 0;
          } else {
              v2 = (11 - v2);
          }

          return (v2 == cnpj[13]);
      } else {
          return (val.length == 0);
      }
   }


    window.showToast = function(messages){
      for(var i = 0; i < messages.length; i++ ){
        var msg = messages[i];
        try {
          toastr[showToastType[msg[0]]](msg[1], '', showToastOptions[msg[0]]);
        } catch(err) {
          toastr.info(msg[1], '', showToastOptions[msg[0]]);
        }
      }
    };

    $('#phone_number').on('cocoon:before-insert', function(e,task_to_be_added) {
      task_to_be_added.find('input.phone').mask('(00) 0000-00009')
      task_to_be_added.find('select.select2').select2()
    })

    $('#addresses').on('cocoon:before-insert', function(e,task_to_be_added) {
      task_to_be_added.find('input.cep').mask('00000-000',cepOptions)
      task_to_be_added.find('select.select2').select2()
    })

    $('#movement_exercise').on('cocoon:before-insert', function(e,task_to_be_added) {
      task_to_be_added.find('select.select2').each(function(){
        var select2_field = $(this);
        if (select2_field.data('url')){
          window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
        } else {
          select2_field.select2()
        }
      })
    })

	$('#combo_movement').on('cocoon:before-insert', function(e,task_to_be_added) {
	  task_to_be_added.find('select.select2').each(function(){
		var select2_field = $(this);
		if (select2_field.data('url')){
		  window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
		} else {
		  select2_field.select2()
		}
	  })
	})

	$('#combo_program').on('cocoon:before-insert', function(e,task_to_be_added) {
	  task_to_be_added.find('select.select2').each(function(){
		var select2_field = $(this);
		if (select2_field.data('url')){
		  window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
		} else {
		  select2_field.select2()
		}
	  })
	})



	$('#person_combo').on('cocoon:before-insert', function(e,task_to_be_added) {
	  task_to_be_added.find('select.select2').each(function(){
		var select2_field = $(this);
		if (select2_field.data('url')){
		  window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
		} else {
		  select2_field.select2()
		}
	  })
	})

  $('#videoPlayerModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget) // Button that triggered the modal
    var videoUrl = button.data('video-url') // Extract info from data-* attributes
    var filenameVideo = button.data('video-filename').toLowerCase()
    // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
    // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
    var modal = $(this)
    modal.find('.modal-title').text('Vídeo ' + button.data('wod') + " - " + button.data('person'))
    modal.find('.modal-body video')[0].firstChild.src = '';
    
    modal.find('.modal-body video')[0].load()

    //modal.find('.modal-body video')[0].src = videoUrl 
    modal.find('.modal-body video')[0].firstChild.src = videoUrl 
    if (filenameVideo.indexOf('.mp4') > 0) {
      modal.find('.modal-body video')[0].firstChild.type = 'video/mp4' 
    } else if (filenameVideo.indexOf('.mov') > 0) {
      modal.find('.modal-body video')[0].firstChild.type='video/quicktime'
    }
    modal.find('.modal-body video')[0].load();
    modal.find('.modal-body a')[0].href = videoUrl
    modal.find('.modal-body a')[0].download = filenameVideo
  })

  $('#ImagensModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget)
    var imageUrls = button.data('image-urls')
    
    var modal = $(this)
    var template = modal.find('#ImageUrlTmpl')

    imageUrls.forEach( (imageUrl) => {
      let html = Mustache.render(template.html(), { url: imageUrl });

      modal.find('.carousel-inner').append(html);
    })

    modal.find('.carousel-item').first().addClass('active');
  })

  });
}

export default Utils;
